import {
  mergeAll,
  fromPairs,
  isEmpty,
  isNil,
  clone,
  path,
  pathOr,
} from "ramda";
import { INITIAL_STATUS } from "../constants/advancements";

export default (realRequirements) => {
  const requirements = clone(realRequirements);
  const hash = mergeAll(
    requirements.map((requirement, i) => fromPairs([[requirement.id, i]]))
  );
  const result = [];

  requirements.forEach((requirement) => {
    requirement.childrenRequired = // eslint-disable-line
      parseInt(requirement.childrenRequired, 10) || 0;

    const parentRequirementId = path(["parentRequirementId"], requirement);
    const parentRequirement = pathOr(
      {},
      [path([parentRequirementId], hash)],
      requirements
    );
    const parentCheck =
      (!parentRequirement || !parentRequirement.listNumber) &&
      !parentRequirement.parentRequirementId;
    if (isEmpty(parentRequirementId) || parentCheck) {
      result.push(requirement);
    } else {
      const parent = requirements[hash[requirement.parentRequirementId]];
      parent.requirements = isNil(parent.requirements)
        ? []
        : parent.requirements;
      parent.childs = isNil(parent.childs) ? 0 : parent.childs;
      parent.requirements.push(requirement);
      parent.childs =
        requirement.status !== INITIAL_STATUS
          ? parent.childs + 1
          : parent.childs;
    }
  });

  const protectCopy = clone(result);
  _sortReq(protectCopy);

  return protectCopy;
};

const _sortReq = (items) => {
  items.sort((a, b) => {
    let aNumb = path(["sortOrder"], a);
    let bNumb = path(["sortOrder"], b);

    if (isEmpty(aNumb) || isEmpty(bNumb) || isNil(aNumb) || isNil(bNumb)) {
      aNumb = pathOr("", ["listNumber"], a).replace(/\.|\(|\)/g, "");
      bNumb = pathOr("", ["listNumber"], b).replace(/\.|\(|\)/g, "");
    }

    const testA = parseFloat(aNumb);
    const testB = parseFloat(bNumb);

    if (!isNaN(testA) && !isNaN(testB)) {
      return testA === testB && aNumb !== bNumb
        ? aNumb.localeCompare(bNumb)
        : testA - testB;
    }
    if (isNaN(testA) && isNaN(testB)) {
      return aNumb.localeCompare(bNumb);
    }

    return 0;
  });

  return items.forEach((item) => {
    if (item.requirements) {
      _sortReq(item.requirements);
    }
  });
};
